export enum AUTH_MODULES {
	MOTIVES_NATIVE = "motives_native_authentication",
	SOCIALITE_AZURE_ENTRA_ID = "socialite_azure_entra_id",
}
